<template>
    <main-content with_go_back_bar>
        <kt-panel class="no-mb">
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#marketer_subsets_list" aria-selected="false">
                                {{ $t('marketing.marketer_managing.marketer_subsets_list') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#marketer_setting" aria-selected="false">
                                {{ $t('marketing.marketer_managing.marketer_setting') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
        </kt-panel>
            <kt-panel-body id="kt-nav">
                <div class="tab-content">
                    <div class="tab-pane active" id="marketer_subsets_list">
                        <marketer-subsets ></marketer-subsets>
                    </div>
                    <div class="tab-pane" id="marketer_setting">
                        <marketer-setting v-if="status === 'success-subsets'"

                                          :marketer_subsets="marketer_subsets"
                                          :status="status"
                        >
                        </marketer-setting>
                    </div>
                </div>
            </kt-panel-body>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import MarketerSubsets from "./components/MarketerSubsets";
    import MarketerSetting from "./components/marketerSettingInManaging"
    import {mapGetters} from "vuex";
    import $ from "jquery";

    export default {
        name: 'marketer_managing',
        components: {
            'marketer-subsets':MarketerSubsets,
            'main-content': mainContent,
            'marketer-setting': MarketerSetting
        },
        computed: {
            ...mapGetters('marketing', [
                'marketer_specific_setting',
                'status',
                'marketer_subsets'
            ])
        },
        data() {
            return {
                active_pane: '#marketer_subsets_list',
                marketer_hashid: this.$route.params.user_id
            }
        },
        methods: {
            filterAction(e, query) {
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }
        },
        mounted() {
            this.$store.dispatch('marketing/fetchSpecificMarketerSetting',this.marketer_hashid)
            this.$store.dispatch('marketing/fetchMarketerSubsets', this.marketer_hashid)
            $('a[data-toggle="tab"]').on('show.bs.tab', (e) => {
                this.active_pane = $(e.target).attr("href")
            })
        },
    }
</script>

<style>
    @media (min-width: 768px) {
        #marketer_subsets_list > div > :first-child {
            border-left: 1px solid #ddd;
        }
    }
</style>